// Milk-volume units. Storage is always ounces (the `amount_oz` column); the
// caretaker just picks how amounts are shown and entered — oz or ml. Display-only
// conversion, so switching units never rewrites data.
//
// Baby bottles are dual-marked at 30 ml per ounce (not the 29.5735 "true" value),
// so we use 30 too — it's what the markings say and it round-trips cleanly:
// 4 oz ⇄ 120 ml, 2 oz ⇄ 60 ml, with no drift a parent would notice.

export type Unit = "oz" | "ml";

export const ML_PER_OZ = 30;

export function isUnit(v: unknown): v is Unit {
  return v === "oz" || v === "ml";
}

export function ozToMl(oz: number): number {
  return Math.round(oz * ML_PER_OZ);
}

export function mlToOz(ml: number): number {
  // Keep two decimals so the stored oz round-trips back to the entered ml.
  return Math.round((ml / ML_PER_OZ) * 100) / 100;
}

/** The number to show/enter in the active unit (oz keeps one decimal, ml is whole). */
export function ozToUnitValue(oz: number, unit: Unit): number {
  return unit === "ml" ? ozToMl(oz) : Math.round(oz * 10) / 10;
}

/** Convert a value typed in the active unit back to stored ounces. */
export function unitValueToOz(value: number, unit: Unit): number {
  return unit === "ml" ? mlToOz(value) : value;
}
